import { useMutation } from "@tanstack/react-query";
import { getFileApiClient } from "@shared/apis/sidekick/api-factories";
import { toast } from "react-toastify";
import { apiResponseErrorHandler } from "@shared/apis/sidekick/api-error-handler";

type Props = {
  onSuccess?: (data: string) => void;
};

export const useAttachFile = (props?: Props) => {
  const { onSuccess } = props || {};
  const fileApi = getFileApiClient();
  const mutation = useMutation({
    mutationFn: async ({ file }: { file: Blob }) => {
      const response = await fileApi.fileControllerUploadPublicFile({
        file,
      });
      onSuccess?.(response);
      return response;
    },
    onError: async (error) => {
      const apiError = await apiResponseErrorHandler(error);
      console.error("Failed to upload a file", apiError);
      if (apiError.status === 413) {
        toast.error(
          "Files must be smaller than 50 MB. Images are limited to 20 MB.",
          { toastId: "upload-file-error" }
        );
        return;
      }

      if (apiError.status >= 400 && apiError.status < 500) {
        toast.error(apiError.errors[0], { toastId: "upload-file-error" });
        return;
      }

      toast.error("Error uploading file", { toastId: "upload-file-error" });
    },
  });

  return mutation;
};
